import React, { useEffect, useRef, useState } from "react";
import ProductGridView from "../productgirdview/product_gridview";
import CartSummary from "../cart_Summary/cartsummary";
import "../productpage/product_page.scss";
import ProductAudienceHeader from "../product_audience_header/product_audience_header";
import { checkP } from "../../../assets";
import {
  audienceFbConnectSucess,
  tokenverfy,
  verfyPayment,
} from "../../../sellers_module/services/seller/api";
import { toast } from "react-toastify";
import {
  loggedIn,
  loggedOut,
} from "../../../sellers_module/store/slice/authSlice";
import { useDispatch } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { captureGAEvent } from "../../../sellers_module/shared/helper";

type Product = {
  _id: string;
  type: string;
  is_purchased: number;
  name: string;
  category: string[];
  price: number;
  discount_price: number;
  audience_size: string;
  image_url: string;
};

interface Option {
  value: string;
  label: string;
}

export default function ProductPage() {
  const [cart, setCart] = useState<Product[]>([]);
  const [activeTab, setActiveTab] = useState<string>("All");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState<string | null>(null);
  const [additionalData, setAdditionalData] = useState<any>(null);

  const urlParams = new URLSearchParams(location.search);
  const razorpay_payment_id = urlParams.get("razorpay_payment_id");
  const razorpay_signature = urlParams.get("razorpay_signature");
  const razorpay_payment_link_id = urlParams.get("razorpay_payment_link_id");
  const razorpay_payment_link_reference_id = urlParams.get(
    "razorpay_payment_link_reference_id"
  );
  const oauthCode = urlParams.get("code");
  const oauthState = urlParams.get("state");
  const [loading, setLoading] = useState<boolean>(false);
  const [accountIds, setAccountIds] = useState<string[]>([]);
  const selectedAccountId = localStorage.getItem("selectedAudienceID") || null;
  const [selectedValue, setSelectedValue] = useState<string>("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [options, setOptions] = useState<Option[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const addToCart = (product: Product) => {
    captureGAEvent(
      "click",
      product.type == "Starter"
        ? "Audience_Purchase_Selected_Starter"
        : "Audience_Purchase_Selected_Growth"
    );
    if (!cart.some((item) => item._id === product._id)) {
      setCart([...cart, product]);
    }
  };

  const removeFromCart = (productId: string) => {
    captureGAEvent("click", "Audience_Checkout_Remove_audience");
    setCart(cart.filter((item) => item._id !== productId));
  };

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  const closePopup = () => {
    cleanupUrlParams();
    setIsPopupVisible(false);
    window.location.reload();
  };

  const cleanupUrlParams = () => {
    const url = new URL(window.location.href);
    url.search = "";
    window.history.replaceState({}, "", url.toString());
  };

  const cleanupUrl = (paramsToDelete: string[]) => {
    try {
      // Get the current URL
      const url = new URL(window.location.href);
      // Remove the specified parameters from the URL
      paramsToDelete.forEach((param) => url.searchParams.delete(param));
      // Update the browser history without reloading the page
      window.history.replaceState({}, document.title, url.toString());
    } catch (error) {
      console.error("Error cleaning up URL parameters:", error);
    }
  };
  const verifyToken = async () => {
    const storedToken = localStorage.getItem("satellizer_token");
    const selectedAudienceID = localStorage.getItem("selectedAudienceID");
    if (!storedToken) {
      console.warn("No stored token found.");
      return;
    }
    const data = {
      token: storedToken,
      validate_token_request: 1,
    };
    try {
      // Call the API to verify the token
      const response = await tokenverfy(data);
      const result = response.data.result || [];

      if (result.length === 0) {
        navigate("/shiprocket_audience/");
        console.warn("No accounts found in the response.");
      }
      // Update Redux store
      dispatch(
        loggedIn({
          userData: {
            first_name: response.data.userData.first_name,
            last_name: response.data.userData.last_name,
            company_name: response.data.userData.company_name,
            email: response.data.userData.email,
          },
          model: {
            company_id: response.data.model.company_id,
          },
          result: result,
          token: storedToken,
        })
      );
      // Generate account options
      const accountOptions = result.map((account) => {
        const cleanedAccountId = account.account_id.replace(/^act_/, "");
        const accountName = account.account_name || "Unknown Account";
        return {
          value: cleanedAccountId,
          label: `Account id - ${cleanedAccountId} (${accountName})`,
        };
      });
      setOptions(accountOptions);
      // Save the first account ID if no selectedAudienceID is stored
      const firstAccountId =
        result.length > 0 ? result[0].account_id.replace(/^act_/, "") : "";
      const selectedValue = selectedAudienceID || firstAccountId;
      if (!selectedAudienceID && firstAccountId) {
        localStorage.setItem("selectedAudienceID", firstAccountId);
      }
      setSelectedValue(selectedValue);
      // Show success message
      toast.success("Token verification successful. Audiences updated.");
      // Clean up authentication-related URL parameters
      cleanupUrl(["code", "state"]);
    } catch (error:any) {
      console.error("Error during token verification:", error?.message);
      toast.error("Token verification failed. Please log in again.");
      // Clear local storage and log out on failure
      localStorage.clear();
      dispatch(loggedOut());
    }
  };

  const verifyPaymentData = async () => {
    setIsLoading(true);
    if (razorpay_payment_id && razorpay_signature) {
      const data = {
        razorpay_payment_id,
        razorpay_signature,
        order_id: razorpay_payment_link_reference_id,
      };

      try {
        const additionalResponse = await verfyPayment(data);
        setAdditionalData(additionalResponse);

        if (additionalResponse.message) {
          cleanupUrlParams();
          setPaymentStatus("success");
        } else {
          setPaymentStatus("failure");
        }
        setIsPopupVisible(true);
      } catch (error) {
        console.error("Error verifying payment", error);
        setPaymentStatus("failure");
        cleanupUrlParams();
        setIsPopupVisible(true);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const updateAccountData = (accounts) => {
    try {
      const savedSelectedValue = localStorage.getItem("selectedAudienceID");

      // If there's no selected value and we have accounts, use the first one
      if (
        !savedSelectedValue &&
        accounts.length > 0 &&
        !selectedValue &&
        !(oauthCode && oauthState)
      ) {
        const firstValue = accounts[0].account_id.replace(/^act_/, ""); // Clean 'act_' prefix
        setSelectedValue(firstValue); // Set the selected value as the first account id
        localStorage.setItem("selectedAudienceID", firstValue); // Save the selected value to localStorage
        verifyToken();
      }

      // Generate dropdown options based on the accounts data
      const accountOptions = accounts.map((account) => {
        const cleanedAccountId = account.account_id.replace(/^act_/, ""); // Clean 'act_' prefix
        const accountName = account.account_name || "Unknown Account"; // Use "Unknown Account" if name is missing
        return {
          value: cleanedAccountId, // Use cleaned account id as value
          label: `${accountName} - ${cleanedAccountId}`, // Format the label
        };
      });

      localStorage.setItem("accounts", JSON.stringify(accounts));

      setOptions(accountOptions);
    } catch (error) {
      console.log("storage error:", error);
    }
  };
  const fetchAccountsFromStorage = () => {
    const storedAccounts = localStorage.getItem("accounts");
    return storedAccounts ? JSON.parse(storedAccounts) : [];
  };

  // Fetch account data from localStorage (fetching from the 'accounts' key now)
  const accounts = fetchAccountsFromStorage();

  const isPaymentVerifyCalled = useRef(false);

  const isFirstTime = useRef(true);

  useEffect(() => {
    const selectedAudienceID = localStorage.getItem("selectedAudienceID");
    const accountsIDS = localStorage.getItem("accounts");

    if (selectedAudienceID) {
      setSelectedValue(selectedAudienceID);
    }
    // If either `selectedAudienceID` or `accounts` is null or empty, call `verifyToken` instantly
    if (
      (!selectedAudienceID || !accountsIDS || accountsIDS === "[]") &&
      !(oauthCode && oauthState)
    ) {
      verifyToken();
    }

    // If `razorpay_payment_id` exists, verify the payment data
    if (razorpay_payment_id && !isPaymentVerifyCalled.current) {
      isPaymentVerifyCalled.current = true;
      console.log("calling verify payment ")

      verifyPaymentData();
      console.log("calling verify after payment verify")
      verifyToken();
      return;
    }
    // If accounts are available in localStorage, update dropdown options
    if (accounts.length > 0) {
      updateAccountData(accounts);
    }
    // Handle OAuth flow if `oauthCode` and `oauthState` are present
    if (oauthCode && oauthState && isFirstTime.current) {
      setLoading(true);
      isFirstTime.current = false;
      const decodedState = decodeURIComponent(oauthState);
      const parsedState = JSON.parse(decodedState);
      const companyId = parsedState.companyId;
      const data = { code: oauthCode, state: companyId };
      audienceFbConnectSucess(data)
        .then((response) => {
          if (response?.data?.status === "Success") {
            const result = response.data.result || [];
            // Save accounts and audience ID to localStorage
            localStorage.setItem("accounts", JSON.stringify(result));

            toast.success(
              "You're all set! Your audiences will be updated automatically."
            );
            setOptions(result);
            const firstAccountId =
              result.length > 0
                ? result[0].account_id.replace(/^act_/, "")
                : "";
            const selectedValue = selectedAudienceID || firstAccountId;
            if (!selectedAudienceID && firstAccountId) {
              localStorage.setItem("selectedAudienceID", firstAccountId);
            }
            setSelectedValue(selectedValue);
          } else {
            console.warn("OAuth response status is not Success.");
          }
        })
        .catch((error) => {
          console.error("Error while syncing audience:", error);
          toast.error("An error occurred while syncing your audience.");
          window.location.href = "/shiprocket_audience/";
        })
        .finally(() => {
          setLoading(false);
          cleanupUrlParams();
        });
    }
  }, [
    razorpay_payment_id,
    razorpay_signature,
    razorpay_payment_link_id,
    oauthCode,
    oauthState,
    selectedValue,
  ]);

  const handleAudienceIdChange = (event) => {
    captureGAEvent("click", "Audience_Purchase_Selected_AccountID");
    const newValue = event.target.value;
    setSelectedValue(newValue);
    localStorage.setItem("selectedAudienceID", newValue);
  };
  function goBack() {
    captureGAEvent("click", "Audience_Purchase_GoBack");
    window.location.href = "/shiprocket_audience/";
  }
  return (
    <>
      {isLoading ? (
        <>
          <div
            style={{
              color: "#f9f9fc",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Full height of the viewport
            }}
          >
            <CircularProgress size={30} color="primary" />{" "}
            {/* Circular Progress */}
          </div>
        </>
      ) : (
        <div>
          <div>
            <ProductAudienceHeader />
          </div>
          <div className="audienceList">
            {/* Go Back button */}
            <Stack
              direction={"column"}
              sx={{
                justifyContent: "space-between",
              }}
            >
              <a
                onClick={() => goBack()} // Navigates to the previous page
                style={{
                  padding: "0px",
                  color: "blue",
                  cursor: "pointer",
                  fontSize: "11px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ArrowBackIcon
                  style={{ marginRight: "8px", marginBottom: "2px" }}
                  sx={{
                    fontSize: 11,
                  }}
                />{" "}
                Go back
              </a>
              <h2 className="p-main-tittle">Select Your Audience Type</h2>
            </Stack>

            <FormControl
              variant="outlined"
              size="small"
              style={{ minWidth: "350px", maxWidth: "350px" }}
            >
              <InputLabel id="audience-select-label">Account</InputLabel>
              <Select
                labelId="audience-select-label"
                value={selectedValue}
                onChange={handleAudienceIdChange}
                label="Account"
              >
                {/* If options are empty, show a default item */}
                {options.length === 0 ? (
                  <MenuItem value="" disabled>
                    No Accounts Available
                  </MenuItem>
                ) : (
                  // Map through options to create dropdown items
                  options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label} {/* Display formatted label */}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </div>

          <div className="app-container">
            <ProductGridView
              audienceId={selectedAccountId}
              addToCart={addToCart}
              cart={cart}
              activeTab={activeTab}
              handleTabClick={handleTabClick}
            />
            <CartSummary cart={cart} removeFromCart={removeFromCart} />
          </div>

          {/* Conditional Popup Modal */}
          {isPopupVisible && (
            <div className={`popup-overlay ${isPopupVisible ? "visible" : ""}`}>
              <div className="popup-content">
                {paymentStatus === "success" ? (
                  <>
                    <div
                      style={{
                        alignSelf: "end",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "black", // Black color for the icon
                      }}
                      onClick={closePopup} // Close popup when clicked
                      title="Close"
                    >
                      ✖
                    </div>
                    <div>
                      <img
                        style={{ justifySelf: "center" }}
                        src={checkP}
                        alt="Check Payment"
                      />
                    </div>
                    <h2 style={{ color: "#43d685" }}>Payment Successful</h2>
                    <h1 style={{ color: "#9b9bb8" }}>
                      You will receive a confirmation mail at
                    </h1>
                    <h1 style={{ color: "black" }}>{additionalData.email}</h1>
                    <h2>Total Amount: ₹{additionalData.amount}</h2>
                  </>
                ) : (
                  <>
                    {/* Close button in the top-right corner */}
                    <div
                      style={{
                        alignSelf: "end",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "black", // Black color for the icon
                      }}
                      onClick={closePopup} // Close popup when clicked
                      title="Close"
                    >
                      ✖
                    </div>

                    {/* Payment Failed Message */}
                    <h2 style={{ color: "red" }}>Payment Failed</h2>
                    <h1 style={{ color: "#9b9bb8" }}>
                      There was an error processing your payment.
                    </h1>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
